import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import apiClient from '../../lib/apiClient';
import storage from '../../lib/storage';
import '../Login.css';

function FacebookIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path fill="#1877F2" d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073c0 6.025 4.388 11.018 10.125 11.927v-8.437H7.078v-3.49h3.047V9.41c0-3.026 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.971H15.83c-1.491 0-1.956.93-1.956 1.886v2.267h3.328l-.532 3.49h-2.796v8.437C19.612 23.091 24 18.098 24 12.073z" />
    </svg>
  );
}

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

function FacebookAuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [status, setStatus] = useState('Processando autenticação com Facebook...');
  const [error, setError] = useState('');

  const handleRetryFacebook = () => {
    setError('');
    window.location.assign(API_URL.replace('/api', '') + '/auth/facebook');
  };

  useEffect(() => {
    const processFacebookCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const authToken = params.get('authToken') || '';
      const fbError = params.get('fb_error') || '';

      if (fbError) {
        setError(decodeURIComponent(fbError));
        setStatus('Não foi possível concluir o login.');
        return;
      }

      if (!authToken) {
        setError('Token de autenticação ausente.');
        setStatus('Não foi possível concluir o login.');
        return;
      }

      try {
        // Temporariamente armazenar o token para fazer a chamada /auth/me
        storage.set('authToken', authToken);

        const data = await apiClient.request('/auth/me');

        if (!data?.success || !data?.user) {
          storage.remove('authToken');
          setError('Falha ao obter dados do usuário.');
          setStatus('Não foi possível concluir o login.');
          return;
        }

        login({
          token: authToken,
          user: {
            name: data.user.name || '',
            email: data.user.email || '',
            id: data.user.id || '',
            plan: data.user.plan || 'free'
          }
        });

        setStatus('Autenticação concluída. Redirecionando...');
        navigate('/dashboard', { replace: true });
      } catch (requestError) {
        storage.remove('authToken');
        setError('Erro de conexão durante autenticação Facebook.');
        setStatus('Não foi possível concluir o login.');
      }
    };

    processFacebookCallback();
  }, [login, navigate]);

  return (
    <div className="login-container">
      <div className="login-shell">
        <aside className="login-hero">
          <div className="login-hero-overlay" />
          <div className="login-hero-content">
            <span className="login-hero-tag">Marketing PRO</span>
            <h1>Conectando com Facebook</h1>
            <p>{status}</p>
          </div>
        </aside>

        <section className="login-panel">
          {error && <div className="error-message">{error}</div>}

          {error && (
            <button className="btn btn-full btn-facebook" type="button" onClick={handleRetryFacebook}>
              <span className="inner">
                <FacebookIcon />
                Tentar novamente com Facebook
              </span>
            </button>
          )}

          <div className="login-footer">
            <div className="signup-link">
              Voltar para <Link to="/login">login</Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default FacebookAuthCallback;
